import ProductTable from "../../components/Table/Product/ProductTable";
import { ItemProps, useItems } from "../../hooks/useFetch";
import Table from "../../layouts/Table";
import React, { useMemo, useRef, useState } from "react";
import { IProduct, OutletType } from "../../types";
import { IUser } from "../../types/userType";

const UserProduct = ({context}: OutletType<IUser>) => {
  const [page, setPage] = useState<number>(1);

  const item = useRef([]);
  const ops = useMemo<Partial<ItemProps>>(() => {
    return { type: "product", all: true, page, ownerId: context._id };
  }, [page, context]);

  const [products, length, loading] = useItems<IProduct>(item.current, ops);

  return (
    <div>
      <Table
        loading={loading}
        title="owned products"
        icon="fas fa-boxes"
        total={length}
        onPageChange={(page) => setPage(page)}
      >
        <ProductTable filter={["owner"]} data={products}></ProductTable>
      </Table>
    </div>
  );
};

export default UserProduct;
